import { render } from "./maxiMize.vue?vue&type=template&id=36e137ee"
import script from "./maxiMize.vue?vue&type=script&lang=js"
export * from "./maxiMize.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__